import { createApp } from 'vue'
import axios from 'axios'
import router from './router'
import App from './App'
import Toast from './plugins/toast'

// CSS imports
import './assets/css/theme.css'
import './assets/sass/enigma.scss'

// Axios config
axios.defaults.baseURL = 'https://api.gigahost.no/api/v0/'

const app = createApp(App)
app.use(router)
app.use(Toast)

// Global properties
app.config.globalProperties.$http = axios

app.mount('#app')
